import { connect } from 'react-redux';
import checkExercise from '../actions/actionCreators/checkExercise';
import showExercise from '../actions/actionCreators/showExercise';
import { showSolution } from '../actions/actionCreators/showSolution';
import { updateLostXp } from '../actions/actionCreators/updateLostXp';
import { Exercise } from '../components/Exercise';
const mapStateToProps = () => ({});
const mapsDispatchToProps = (dispatch, _ref) => {
  let {
    exerciseId
  } = _ref;
  return {
    checkExercise: (message, success, groupedItems) => dispatch(checkExercise(exerciseId, message, success, groupedItems)),
    showExercise: () => dispatch(showExercise(exerciseId)),
    showSolution: () => dispatch(showSolution({
      exerciseId
    })),
    updateLostXp: _ref2 => {
      let {
        exerciseId: id,
        lostXp
      } = _ref2;
      return dispatch(updateLostXp({
        exerciseId: id,
        lostXp
      }));
    }
  };
};
export default connect(mapStateToProps, mapsDispatchToProps)(Exercise);